import React from "react";
import { useTranslation } from "react-i18next";
import { useAtom } from "jotai";
import { izProviderConfigsAtom, isHydrated } from "../../jotai/atoms";
import i18n from "../../i18n";

export function Discover() {
  const { t } = useTranslation();
  const [providerConfigs] = useAtom(izProviderConfigsAtom);

  const validProviders = isHydrated(providerConfigs)
    ? providerConfigs
        .filter((p) => i18n.exists(`discover.page_${p.iz_provider.destination_id.toLowerCase()}`))
        .sort((a, b) => (a.iz_provider.name < b.iz_provider.name ? -1 : 1))
    : [];

  const allItems = [
    { id: "about", src: "/assets/images/Discover_1_Light.png", label: t("discover.page1") },
    ...validProviders.map((provider) => {
      const destinationId = provider.iz_provider.destination_id.toLowerCase();
      return {
        id: destinationId,
        src: `/assets/images/Discover_${destinationId.toUpperCase()}.png`,
        label: t(`discover.page_${destinationId}`),
      };
    }),
    { id: "doctors", src: "/assets/images/Doctors_Background.png", label: t("discover.page3") },
  ];

  return (
    <>
      {/* Carousel for small screens */}
      <div
        className="carousel carousel-center w-full rounded-box space-x-4 p-4 text-center text-primary-content md:hidden"
        data-testid="discover-container"
      >
        {allItems.map((item) => (
          <div key={item.id} className="carousel-item w-5/6 max-w-sm">
            <div className="flex flex-col items-center">
              <img src={item.src} alt="" />
              <div className="badge badge-xl font-bold h-fit w-2/3">{item.label}</div>
            </div>
          </div>
        ))}
      </div>

      {/* Grid for md and larger screens */}
      <div
        className="hidden md:grid grid-cols-3 gap-0 p-4 text-center text-primary-content "
        data-testid="discover-grid"
      >
        {allItems.map((item) => (
          <div key={item.id} className="flex flex-col items-center">
            <img src={item.src} alt="" className="max-h-[500px]" />
            <div className="badge badge-xl font-bold h-fit w-2/3">{item.label}</div>
          </div>
        ))}
      </div>
    </>
  );
}

export default Discover;
